import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import useCMSHeaderAndGridLayout from '@swf/core/hooks/useCMSHeaderAndGridLayout';
import { FirstLoader } from '@swf/first';

import RMF from './RMF';

const RMFWizard = () => {
  const cmsHeaderAndGridLayout = useCMSHeaderAndGridLayout();

  return (
    <StarsWizard
      flow={[RMF]}
      loader={<FirstLoader />}
      cmsHeaderAndGridLayout={cmsHeaderAndGridLayout}
    >
      <RMF />
    </StarsWizard>
  );
};

export default RMFWizard;
